<script lang="ts">
  import LoadingAtom from "$components/+blocks/Loading/LoadingAtom.svelte";
</script>

<div
  class="overflow-hidden rounded-lg border-[0.5px] border-black/10 bg-white p-4 dark:border-white/10 dark:bg-white/3"
>
  <div class="flex items-center justify-between">
    <!-- top row LHS -->
    <div class="flex w-full items-center space-x-2.5">
      <!-- for avatar -->
      <LoadingAtom size="size-5" radius="rounded-md" />
      <!-- for author name -->
      <LoadingAtom size="h-2 w-16" />
      <!-- for role tags -->
      <LoadingAtom size="h-2 w-8" />
    </div>
    <!-- top row RHS -->
    <div class="flex items-center gap-4">
      <!-- for creation time interval -->
      <LoadingAtom size="h-2 w-16" />
      <!-- for action button -->
      <LoadingAtom size="size-2" />
    </div>
  </div>
  <div class="my-4 grid w-full grid-cols-6 space-y-4 py-1">
    <!-- for text content -->
    <LoadingAtom size="col-span-4 h-2" />
    <LoadingAtom size="col-span-5 h-2" />
    <LoadingAtom size="col-span-2 h-2" />
  </div>

  <div class="my-2 flex flex-wrap items-center justify-between">
    <div class="flex items-center gap-2">
      <!-- for buttons -->
      <LoadingAtom size="w-8 h-2" />
      <LoadingAtom size="w-12 h-2" />
    </div>
  </div>
</div>
